import Alert from 'common/components/alert/Alert';
import Page from 'common/components/page/Page';
import { PageTemplates } from 'common/components/page/PageTemplates';
import AlertType from 'common/types/AlertType';
import FetchStatus from 'common/types/FetchStatus';
import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PasswordInput from '../components/PasswordInput';
import UsernameInput from '../components/UsernameInput';

interface ILoginPresenter {
  error: string;
  fetchStatus: FetchStatus;
  username: string;
  password: string;
  hasSubmitted: boolean;
  showEmailVerified: boolean;
  onUsernameChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onLoginClick: () => void;
  confirmEmail: boolean;
  hasDevCredentials: boolean;
  onDevLoginClick: () => void;
}

const LoginPresenter = (props: ILoginPresenter) => {
  return (
    <Page template={PageTemplates.centered}>
      <Card>
        <Card.Body>
          {props.error && <Alert type={AlertType.danger}>{props.error}</Alert>}
          {props.showEmailVerified && (
            <Alert type={AlertType.success}>
              Success! Your email has been verified.
            </Alert>
          )}
          {props.confirmEmail && (
            <Alert type={AlertType.danger}>
              <p>
                Please confirm your email prior to logging in. If you have not
                received an email,{' '}
                <Link
                  to={{
                    pathname: '/auth/send-confirmation',
                    state: { email: props.username },
                  }}
                >
                  click here
                </Link>{' '}
                to send another email.
              </p>
            </Alert>
          )}
          <h3 className='mb-3'>Log in</h3>
          <p>
            or <Link to='/auth/create-account'>create an account</Link>
          </p>
          <UsernameInput
            onChange={props.onUsernameChange}
            error={
              props.hasSubmitted && !props.username
                ? 'Email field cannot be left blank.'
                : undefined
            }
          />
          <PasswordInput
            onChange={props.onPasswordChange}
            error={
              props.hasSubmitted && !props.password
                ? 'Password field cannot be left blank.'
                : undefined
            }
          />
          <Button
            type='button'
            color='primary'
            className='px-5 my-2'
            onClick={props.onLoginClick}
            disabled={props.fetchStatus === FetchStatus.loading}
          >
            Log in
          </Button>
          {props.hasDevCredentials && (
            <Button
              type='button'
              color='primary'
              className='px-5 my-2'
              onClick={props.onDevLoginClick}
              disabled={props.fetchStatus === FetchStatus.loading}
            >
              Log in (dev)
            </Button>
          )}
          <div>
            <Link to='/auth/forgot-password' className='btn btn-link px-0'>
              Forgot password?
            </Link>
          </div>
        </Card.Body>
      </Card>
    </Page>
  );
};

export default LoginPresenter;
